<p-message
  size="small"
  severity="success"
  icon="pi pi-video"
  styleClass="mb-2"
  *ngIf="systemService.configuracao()?.exibeChamadaCentralConhecimento">
  Você já conhece a nossa central de conhecimento, com tutoriais e vídeos do
  CONFEAR?
  <a href="https://faq.egtec.com.br/confear" target="_blank">
    Clique aqui para acessar
  </a>
  !
</p-message>
<app-page-wrapping [pageTitle]="pageTitle">
  <section content>
    <section class="container-home">
      <dx-data-grid
        class="grid-container"
        id="gridContainer"
        [hoverStateEnabled]="true"
        [columnMinWidth]="100"
        [allowColumnResizing]="true"
        [dataSource]="dataSource"
        [remoteOperations]="false"
        [allowColumnReordering]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true">
        <dxo-search-panel
          [width]="240"
          [visible]="true"
          [highlightCaseSensitive]="true"></dxo-search-panel>
        <dxo-group-panel [visible]="true"></dxo-group-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-grouping [autoExpandAll]="false"></dxo-grouping>
        <dxo-selection mode="single"></dxo-selection>
        <dxo-grouping [autoExpandAll]="false"></dxo-grouping>
        <dxo-group-panel
          emptyPanelText="Arraste uma coluna para agrupar"
          [visible]="true"></dxo-group-panel>
        <dxo-toolbar>
          <dxi-item>
            <div
              *ngIf="loggedUser?.indAdministradorSistema"
              (click)="toggleDrawerFilter()"
              class="btn-filtro"
              title="Abre os filtros avançados">
              <i class="pi pi-filter-slash"></i>
              <span class="btn-label">FILTROS</span>
            </div>
          </dxi-item>
          <dxi-item name="searchPanel" location="after"></dxi-item>
          <dxi-item title="Atualiza lista" text="Refresh" [visible]="true">
            <dx-button icon="refresh" (onClick)="refreshDataGrid()"></dx-button>
          </dxi-item>
          <dxi-item name="groupPanel"></dxi-item>
        </dxo-toolbar>
        <dxi-column
          [width]="'100px'"
          filterType="exclude"
          [allowSearch]="false"
          cssClass="container-icon-status"
          alignment="center"
          caption="STATUS"
          dataType="number"
          dataField="status.descricao"
          cellTemplate="statusTemplate"></dxi-column>
        <dxi-column
          dataType="string"
          alignment="left"
          caption="EMPRESA"
          [width]="'170px'"
          dataField="nomeFantasia"
          cellTemplate="empresaTemplate"></dxi-column>
        <div
          *dxTemplate="let data of 'empresaTemplate'"
          [title]="
            'Em operação desde ' +
            (data?.data?.dataIntegracaoCertificado | date: 'dd/MM/yyyy HH:mm')
          ">
          {{ data?.value }}
        </div>
        <dxi-column
          dataType="string"
          alignment="center"
          [width]="'100px'"
          caption="FILIAL"
          dataField="filial"></dxi-column>
        <dxi-column
          [width]="'50px'"
          alignment="center"
          dataType="string"
          caption="UF"
          dataField="endereco.uf"></dxi-column>
        <dxi-column
          [minWidth]="150"
          caption="DATA ÚLTIMA VERIFICAÇÃO"
          dataType="date"
          alignment="center"
          dataField="dataUltimaVerificacao"
          cellTemplate="ultimaCaptacao"></dxi-column>
        <dxi-column
          [minWidth]="150"
          caption="DATA EMISSÃO NFE MAIS RECENTE"
          dataType="date"
          alignment="center"
          dataField="dataEmissaoNFeMaisRecente"
          cellTemplate="emissaoNfeRecente"></dxi-column>
        <dxi-column
          caption="CERTIFICADO DIGITAL"
          [minWidth]="130"
          dataType="date"
          dataField="dataValidade"
          cellTemplate="progressBarTemplate"></dxi-column>
        <dxi-column
          alignment="center"
          dataType="number"
          [width]="'100px'"
          caption="NF-E ARMAZENADAS"
          dataField="totalNfeArmazenadas"
          cellTemplate="nfeArmazenadasTemplate"></dxi-column>
        <div
          class="text-center"
          *dxTemplate="let data of 'nfeArmazenadasTemplate'">
          {{ data.value | number }}
        </div>

        <div *dxTemplate="let data of 'statusTemplate'">
          <app-icone
            [id]="data?.data?.id"
            (mouseenter)="toggleWithTemplate(data?.data)"
            (mouseleave)="toggleWithTemplate(data?.data)"
            [icon]="data?.data?.status?.icone"
            [title]="data?.data?.status?.descricao"></app-icone>
          <dx-tooltip
            *ngIf="data?.data?.status.id === statusNotaNaoCaptando"
            [target]="currentTooltip?.nativeElement"
            [(visible)]="withTemplateVisible"
            [hideOnOutsideClick]="false">
            <div *dxTemplate="let data = data of 'content'">
              <app-tooltip-conteudo
                title="ERRO APRESENTADO"
                text="A nota fiscal eletrônica não consta na base
                 de dados da SEFAZ estadual."></app-tooltip-conteudo>
            </div>
          </dx-tooltip>
        </div>

        <div *dxTemplate="let data of 'progressBarTemplate'">
          <div class="container-progressbar">
            <ng-container
              *ngIf="data?.data?.dataValidade; else aguardandoCertificado">
              <dx-progress-bar
                [class.progressbar-blue]="
                  data?.data.progress >= 0 && data?.data.progress < 30
                "
                [class.progressbar-green]="
                  data?.data.progress >= 30 && data?.data.progress < 60
                "
                [class.progressbar-yellow]="
                  data?.data.progress >= 60 && data?.data.progress < 91
                "
                [statusFormat]="formatBarLabel"
                [class.progressbar-red]="data?.data.progress >= 91"
                [class.complete]="data?.data.progress === 100"
                [min]="0"
                [max]="100"
                [value]="data?.data.progress"></dx-progress-bar>
              <span>
                {{ formatLabelProgressbar(data) }}
              </span>
            </ng-container>
            <ng-template #aguardandoCertificado>
              <span class="text-center">Aguardando certificado digital</span>
            </ng-template>
          </div>
        </div>

        <div *dxTemplate="let data of 'ultimaCaptacao'" class="text-center">
          <ng-container
            *ngIf="data?.data?.dataUltimaVerificacao; else aguardandoCaptacao">
            {{ data.data.dataUltimaVerificacao | date: 'dd/MM/yyyy HH:mm' }}
          </ng-container>
          <ng-template #aguardandoCaptacao>
            <span>Aguardando captação</span>
          </ng-template>
        </div>

        <div *dxTemplate="let data of 'emissaoNfeRecente'" class="text-center">
          <ng-container
            *ngIf="
              data?.data?.dataEmissaoNFeMaisRecente;
              else emissaoNfeRecente
            ">
            {{ data.data.dataEmissaoNFeMaisRecente | date: 'dd/MM/yyyy HH:mm' }}
          </ng-container>
          <ng-template #emissaoNfeRecente>
            <span>Aguardando captação</span>
          </ng-template>
        </div>
      </dx-data-grid>
      <div class="container-status-sefaz">
        <div class="container-title">
          <h1 class="title-sefaz">STATUS SEFAZ</h1>
          <span
            #iconSefaz
            (mouseenter)="toggleWithTemplateSefaz()"
            (mouseleave)="toggleWithTemplateSefaz()"
            class="material-icons-outlined"
            id="icon-info">
            info
          </span>
          <dx-tooltip
            [target]="iconSefaz"
            [(visible)]="toggleVisibileSefaz"
            [hideOnOutsideClick]="false">
            <div *dxTemplate="let data = data of 'content'">
              <app-tooltip-conteudo
                text="Lista dos status da SEFAZ por cada estado com
                 o informe de seus problemas. "></app-tooltip-conteudo>
            </div>
          </dx-tooltip>
        </div>
        <section class="sefaz-table">
          <div class="sefaz-table-header">
            <div class="item-header">UF</div>
            <div class="item-header">STATUS</div>
          </div>
          <div class="sefaz-table-body">
            <div class="row" *ngFor="let item of statuSefazList">
              <span class="item-body">{{ item.uf }}</span>
              <div class="item-body-status">
                <span appStatusSefaz [status]="item.idStatus">
                  {{ item.status }}
                </span>
                <span
                  *ngIf="item.idStatus !== statusSefazOtimo"
                  class="status-hour-delay">
                  Atraso de até
                  {{ item.mediaHoras | time }}
                </span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </section>
</app-page-wrapping>
<app-drawer
  *ngIf="loggedUser?.indAdministradorSistema"
  (closeDrawer)="listenDrawer($event)"
  [titleDrawer]="'Filtro Avançado'"
  [visible]="filterVisible">
  <app-inicio-filtros
    (filters)="listenFilterValues($event)"
    content></app-inicio-filtros>

  <div class="col-12 flex justify-content-start p-1" footer>
    <p-button
      (click)="send()"
      id="btn-pesquisar"
      label="Pesquisar"
      class="btn-azul-padrao ml-2 mr-2"
      type="button"
      title="Pesquisar"
      icon="pi pi-search"
      iconPos="left"></p-button>
    <p-button
      (click)="reset()"
      id="btn-limpar"
      class="btn-roxo mr-2"
      type="button"
      title="Limpar Filtros"
      icon="pi pi-filter-slash"
      iconPos="left"></p-button>
  </div>
</app-drawer>

<app-modal-usuario-config-setup
  [display]="openModalUpdateUserRegister"></app-modal-usuario-config-setup>

<app-modal-inicio-info [open]="openModalInfo"></app-modal-inicio-info>
